<template>
    <div class="main-box">
        <div class="main-container">
            <div class="apply-form">
                <div class="container" v-loading="loading" v-if="!empty && !result">
                    <div class="header">
                        <div class="title">
                            <span class="urgent" v-if="post.urgentFlag === 1">急</span>
                            {{post.postName}}
                            <div class="salary" v-if="[null, '', undefined].indexOf(post.minimalSalary) === -1 &&
                                [null, '', undefined].indexOf(post.maximumSalary) === -1 && [null, '', undefined].indexOf(post.salaryMonth) === -1">
                                {{(post.minimalSalary === 0 && post.maximumSalary === 0)?'':(post.minimalSalary + '-' + post.maximumSalary + 'K·' + post.salaryMonth + '薪')}}
                            </div>
                        </div>
                        <div class="status">
                            <span class="item" v-if="post.area" v-html="post.area.areaName"></span>
                            <span class="item" v-if="post.postType" v-html="post.postType.postTypeName"></span>
                            <span class="item" v-if="post.org" v-html="post.org.orgName"></span>
                            <span class="status-item" v-if="post.demandNumber" v-html="post.demandNumber + '人'"></span>
                        </div>
                    </div>
                    <div class="content">
                        <div class="classify-label" v-if="post.recruitmentFaceToType !== 3">上传简历</div>
                        <el-upload action="#" :auto-upload="false" :on-change="fileUploadChange" :show-file-list="false" v-if="post.recruitmentFaceToType !== 3">
                            <template #default>
                                <el-button type="info" style="width:100%">
                                    {{uploadFile.fileName?uploadFile.fileName:'上传简历'}}
                                </el-button>
                                <div slot="tip" class="el-upload__tip">支持pdf','doc','ppt','docx','pptx','wps','html','jpg','jpeg','png','rtf','txt等简历格式，大小请限制在5MB以内</div>
                            </template>
                        </el-upload>
                        <el-form label-position="top" class="post-form" :model="applyForm" :rules="formRules" ref="ruleForm">
                            <div class="classify-label">个人信息</div>
                            <el-row>
                                <el-col :span="12" class="form-col">
                                    <el-form-item label="姓名" prop="candidateName">
                                        <el-input v-model="applyForm.candidateName" placeholder="姓名"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="form-col" v-if="post.recruitmentFaceToType !== 3">
                                    <el-form-item label="拼音名/英文名">
                                        <el-input v-model="applyForm.englishName" placeholder="拼音名/英文名"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="form-col">
                                    <el-form-item label="身份证" prop="idCardNumber" key="idCardNumber">
                                        <el-input v-model="applyForm.idCardNumber" placeholder="身份证" class="input-with-select">
                                            <el-select v-model="applyForm.idCardCategory" slot="prepend">
                                                <el-option label="身份证" :value="1"></el-option>
                                                <el-option label="身份证（中国香港）" :value="2"></el-option>
                                                <el-option label="身份证（中国澳门）" :value="3"></el-option>
                                                <el-option label="身份证（中国台湾）" :value="4"></el-option>
                                                <el-option label="身份证（护照）" :value="5"></el-option>
                                                <el-option label="其他证件" :value="6"></el-option>
                                            </el-select>
                                        </el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="form-col">
                                    <el-form-item label="民族">
                                        <el-select style="width:100%" placeholder="民族" v-model="applyForm.nation" filterable>
                                            <el-option v-for="nation of nationList" :key="nation" :label="nation" :value="nation"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="form-col" v-if="post.recruitmentFaceToType === 2">
                                    <el-form-item label="政治面貌">
                                        <el-select style="width:100%" placeholder="政治面貌" v-model="applyForm.politicalOutlook" filterable>
                                            <el-option label="中共党员" value="中共党员"></el-option>
                                            <el-option label="共青团员" value="共青团员"></el-option>
                                            <el-option label="群众" value="群众"></el-option>
                                            <el-option label="其他" value="其他"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="form-col" v-if="post.recruitmentFaceToType !== 1">
                                    <el-form-item label="出生日期(年龄)">
                                        <el-date-picker v-model="applyForm.birthday" type="date" placeholder="出生日期(年龄)" style="width:100%" @change="birthdaySelect"
                                        :format="birthdayFormat"></el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="form-col">
                                    <el-form-item label="手机号" prop="phone" key="phone">
                                        <el-input v-model="applyForm.phone" placeholder="手机号"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="form-col" v-if="post.recruitmentFaceToType !== 3">
                                    <el-form-item label="邮箱" prop="email" key="email">
                                        <el-input v-model="applyForm.email" placeholder="邮箱"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="form-col" v-if="post.recruitmentFaceToType !== 3">
                                    <el-form-item label="紧急联系电话">
                                        <el-input v-model="applyForm.emergencyContactPhone" placeholder="紧急联系电话"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="form-col">
                                    <el-form-item label="性别"  prop="gender" key="gender">
                                        <el-select style="width:100%" placeholder="性别" v-model="applyForm.gender">
                                            <el-option label="男" :value="1"></el-option>
                                            <el-option label="女" :value="0"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="form-col" v-if="post.recruitmentFaceToType !== 3">
                                    <el-form-item label="现居住地">
                                        <el-input v-model="applyForm.residentialAddress" placeholder="现居住地"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="form-col"  >
                                    <el-form-item label="户籍所在地"   prop="permanentAddress" key="permanentAddress">
                                        <el-input v-model="applyForm.permanentAddress" placeholder="户籍所在地"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="form-col" v-if="post.recruitmentFaceToType === 1">
                                    <el-form-item label="到岗时间">
                                        <el-input v-model="applyForm.arrivalTime" placeholder="到岗时间"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="form-col" v-if="post.recruitmentFaceToType === 2">
                                    <el-form-item label="毕业时间">
                                        <el-date-picker v-model="applyForm.graduationTime" type="date" placeholder="毕业时间" style="width:100%"></el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="form-col" v-if="post.recruitmentFaceToType !== 1">
                                    <el-form-item label="学历">
                                        <el-select style="width:100%" placeholder="学历" v-model="applyForm.highestEducation">
                                            <el-option label="本科" value="本科"></el-option>
                                            <el-option label="硕士" value="硕士"></el-option>
                                            <el-option label="博士" value="博士"></el-option>
                                            <el-option label="高中" value="高中"></el-option>
                                            <el-option label="大专" value="大专"></el-option>
                                            <el-option label="中专" value="中专"></el-option>
                                            <el-option label="MBA" value="MBA"></el-option>
                                            <el-option label="其他" value="其他"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24" class="form-col" v-if="post.recruitmentFaceToType === 1">
                                    <el-form-item label="您目前或曾经是否在璞泰来新能源科技股份有限公司、其子公司、合资公司面试？">
                                        <el-select style="width:100%" placeholder="请选择" v-model="applyForm.selfReportRepeatFlag">
                                            <el-option label="是" :value="1"></el-option>
                                            <el-option label="否" :value="0"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <div class="classify-label" v-if="post.recruitmentFaceToType !== 3">求职意向</div>
                            <el-row v-if="post.recruitmentFaceToType !== 3">
                                <el-col :span="12" class="form-col" v-if="post.recruitmentFaceToType === 1">
                                    <el-form-item label="期望薪资">
                                        <el-input v-model="applyForm.salaryExpectation" placeholder="期望薪资"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="form-col" v-if="post.recruitmentFaceToType === 2">
                                    <el-form-item label="是否接受岗位调剂">
                                        <el-select style="width:100%" placeholder="请选择" v-model="applyForm.agreePostAdjustFlag">
                                            <el-option label="是" :value="1"></el-option>
                                            <el-option label="否" :value="0"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="form-col" v-if="post.recruitmentFaceToType === 2">
                                    <el-form-item label="是否接受地点调剂">
                                        <el-select style="width:100%" placeholder="请选择" v-model="applyForm.agreeAreaAdjustFlag">
                                            <el-option label="是" :value="1"></el-option>
                                            <el-option label="否" :value="0"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <div class="classify-label">获取招聘信息渠道</div>
                            <el-row>
                                <el-col :span="24" class="form-col">
                                    <el-form-item label="获取招聘信息渠道">
                                        <el-select style="width:100%" placeholder="请选择" v-model="applyForm.recruitmentChannel">
                                            <el-option label="企业官网/官微" value="企业官网/官微"></el-option>
                                            <el-option label="学校/学院就业网" value="学校/学院就业网"></el-option>
                                            <el-option label="学校微信公众号" value="学校微信公众号"></el-option>
                                            <el-option label="老师/学长姐推荐" value="老师/学长姐推荐"></el-option>
                                            <el-option label="宣讲会" value="宣讲会"></el-option>
                                            <el-option label="线下宣传（海报/折页/横幅等）" value="线下宣传（海报/折页/横幅等）"></el-option>
                                            <el-option label="内部推荐" value="内部推荐"></el-option>
                                            <el-option label="其他" value="-1"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="form-col" v-if="applyForm.recruitmentChannel === '-1'">
                                    <el-form-item label="其他渠道">
                                        <el-input v-model="applyForm.recruitmentChannelOther" placeholder="其他渠道"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="form-col" v-if="applyForm.recommenderWorkNo === ''">
                                    <el-form-item label="内推人姓名">
                                        <el-input v-model="applyForm.recommenderName" placeholder="内推人姓名"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="form-col" v-if="applyForm.recommenderWorkNo === ''">
                                    <el-form-item label="内推人电话">
                                        <el-input v-model="applyForm.recommenderPhone" placeholder="内推人电话"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                    <div class="footer">
                        <el-button type="primary" style="width:100%" @click="ConfirmApply">确认申请</el-button>
                    </div>
                </div>
                <div class="container" v-if="empty">
                    <el-empty description="抱歉，该职位已停止招聘，去看看其他机会吧！">
                        <el-button type="primary" size="small" @click="otherPostClick">查看其他岗位</el-button>
                    </el-empty>
                </div>
                 <div class="container" v-if="result">
                    <el-result icon="success" title="成功提示" subTitle="申请成功"></el-result>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import api from '@/api';
import dayjs from 'dayjs';
// import dayjs from 'dayjs';
export default {
    name: 'PostApply',
    data() {
        const validatePass = (rule, value, callback) => {
            if (value === '') {
                callback();
            } else {
                let reg = null;
                switch (rule.field) {
                case 'idCardNumber':
                    if (this.applyForm.idCardCategory === 1) {
                        reg = new RegExp('(^[1-9]\\d{5}(18|19|([23]\\d))\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{3}[0-9Xx]$)|(^[1-9]\\d{5}\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{2}$)');
                        if (!reg.test(value)) { // 正则验证不通过，格式不对
                            callback(new Error('身份证格式不正确'));
                        }
                    }
                    if (this.applyForm.idCardCategory === 2) {
                        reg = new RegExp('^[A-Z]\\d{6}\\([\\dA]\\)$');
                        if (!reg.test(value)) { // 正则验证不通过，格式不对
                            callback(new Error('身份证格式不正确'));
                        }
                    }
                    if (this.applyForm.idCardCategory === 3) {
                        reg = new RegExp('[1|5|7]\\d{6}[(\\d)]{3}');
                        if (!reg.test(value)) { // 正则验证不通过，格式不对
                            callback(new Error('身份证格式不正确'));
                        }
                    }
                    if (this.applyForm.idCardCategory === 4) {
                        reg = new RegExp('^[A-Z][21]\\d{8}$');
                        if (!reg.test(value)) { // 正则验证不通过，格式不对
                            callback(new Error('身份证格式不正确'));
                        }
                    }
                    break;
                case 'phone':
                    reg = new RegExp('^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\\d{8}$');
                    if (!reg.test(value)) { // 正则验证不通过，格式不对
                        callback(new Error('手机号格式不正确'));
                    }
                    break;
                }
                callback();
            }
        };
        return {
            applyForm: {
                areaId: '',
                postId: '',
                candidateName: '',
                englishName: '',
                age: '',
                birthday: '',
                gender: '',
                country: '',
                nation: '',
                politicalOutlook: '',
                idCardNumber: '',
                idCardCategory: 1,
                residentialAddress: '',
                permanentAddress: '',
                phone: '',
                email: '',
                highestEducation: '',
                graduationTime: '',
                arrivalTime: '',
                relationshipFlag: '',
                selfReportRepeatFlag: '',
                agreePostAdjustFlag: '',
                agreeAreaAdjustFlag: '',
                salaryExpectation: '',
                recruitmentChannel: '',
                recruitmentChannelOther: '',
                recommenderWorkNo: '',
                recommenderName: '',
                recommenderPhone: ''
            },
            uploadFile: {
                file: '',
                fileName: ''
            },
            formRules: {
                candidateName: [{ required: true, message: '请输入姓名', trigger: 'change' }],
                idCardNumber: [{ validator: validatePass, trigger: 'blur' }, { required: true, message: '请输入身份证号码', trigger: 'change' }],
                phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }, { validator: validatePass, trigger: 'blur' }],
                gender: [{ required: true, message: '请输入性别', trigger: 'change' }],
                permanentAddress: [{ required: true, message: '请输入户籍所在地', trigger: 'change' }],
                email: [{ type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }]
            },
            loading: true,
            empty: false,
            result: false,
            post: {},
            nationList: ['N/A', '汉族', '满族', '蒙古族', '回族', '藏族', '维吾尔族', '苗族', '彝族', '壮族', '布依族', '侗族', '瑶族', '白族', '土家族', '哈尼族', '哈萨克族', '傣族',
                '黎族', '傈僳族', '佤族', '畲族', '高山族', '拉祜族', '水族', '东乡族', '纳西族', '景颇族', '柯尔克孜族', '土族', '达斡尔族', '仫佬族', '羌族', '布朗族', '撒拉族',
                '毛南族', '仡佬族', '锡伯族', '阿昌族', '普米族', '朝鲜族', '塔吉克族', '怒族', '乌孜别克族', '俄罗斯族', '鄂温克族', '德昂族', '保安族', '裕固族', '京族', '塔塔尔族',
                '独龙族', '鄂伦春族', '赫哲族', '门巴族', '珞巴族', '基诺族'],
            birthdayFormat: 'yyyy-MM-dd(23岁)'
        };
    },
    created() {
        this.applyForm.postId = this.$route.params.id;
        this.applyForm.recommenderWorkNo = this.$store.state.promoterId ? decodeURIComponent(this.$store.state.promoterId) : '';
        this.getDetailByPostId(this.$route.params.id);
    },
    methods: {
        // 根据ID获取岗位详情
        async getDetailByPostId(id) {
            this.loading = true;
            const res = await api.post.getDetailByPostId(id);
            this.loading = false;
            if (res.code !== 200 || !res.data) {
                this.empty = true;
                return;
            }
            res.data.duty = res.data.duty ? res.data.duty.split(/[(\r\n)\r\n]+/) : [];
            res.data.requirement = res.data.requirement ? res.data.requirement.split(/[(\r\n)\r\n]+/) : [];
            this.post = res.data;
        },
        // 查看更多岗位点击
        otherPostClick() {
            if (sessionStorage.getItem('ptlPageType')) {
                this.$router.push('/' + sessionStorage.getItem('ptlPageType') + '/job');
            } else {
                this.$router.push('/job/' + (this.post.recruitmentFaceToType === 1 ? 'social' : this.post.recruitmentFaceToType === 2 ? 'campus' : 'worker'));
            }
        },
        // 文件上传
        fileUploadChange(file) {
            if (file.size > 5242880) {
                this.$message.error('文件大小过大，请修改后再上传！');
                return;
            }
            const fileFormat = file.name.substring(file.name.lastIndexOf('.') + 1, file.name.length);
            if (['pdf', 'doc', 'ppt', 'docx', 'pptx', 'wps', 'html', 'jpg', 'jpeg', 'png', 'rtf', 'txt'].indexOf(fileFormat) === -1) {
                this.$message.error('请上传规定格式简历！');
                return;
            }
            this.uploadFile = { file: file.raw, fileName: file.name };
        },
        // 添加验证字段是否合格
        ConfirmApply() {
            this.$refs.ruleForm.validate((valid) => {
                if (!valid) {
                    return;
                }
                this.addResume();
            });
        },
        // 添加简历
        async addResume() {
            this.loading = true;
            const res = await api.resume.insertResume(this.applyForm.areaId, this.applyForm.postId, this.applyForm.candidateName, this.applyForm.englishName,
                this.applyForm.age, this.applyForm.birthday ? dayjs(this.applyForm.birthday).format('YYYY-MM-DD hh:mm:ss') : '', this.applyForm.gender,
                this.applyForm.country, this.applyForm.nation, this.applyForm.politicalOutlook, this.applyForm.idCardNumber,
                this.applyForm.idCardCategory, this.applyForm.residentialAddress, this.applyForm.permanentAddress, this.applyForm.phone, this.applyForm.email,
                this.applyForm.highestEducation, this.applyForm.graduationTime ? dayjs(this.applyForm.graduationTime).format('YYYY-MM-DD hh:mm:ss') : '',
                this.applyForm.arrivalTime, this.applyForm.relationshipFlag, this.applyForm.selfReportRepeatFlag, this.applyForm.agreePostAdjustFlag,
                this.applyForm.agreeAreaAdjustFlag, this.applyForm.salaryExpectation, this.applyForm.recruitmentChannel, this.applyForm.recruitmentChannelOther,
                this.applyForm.recommenderWorkNo, this.applyForm.recommenderName, this.applyForm.recommenderPhone, this.uploadFile.file, 0);
            this.loading = false;
            if (res.code !== 200) {
                this.$message.error(res.msg);
                return;
            }
            this.result = true;
        },
        // 生日日期选择
        birthdaySelect() {
            const age = dayjs().diff(dayjs(this.applyForm.birthday), 'year') + 1;
            this.birthdayFormat = 'yyyy-MM-dd(' + age + '岁)';
            this.applyForm.age = age;
        }
    }
};
</script>
<style lang="scss" scoped>
.main-box {
    overflow: auto;
    position: relative;
    height: 100%;
    border-top: 80px solid #00003C;
    box-sizing: border-box;
}
.main-container {
    width: 880px;
    min-width: 880px;
    height: 100%;
    box-sizing: border-box;
    margin: auto;
    .apply-form {
        text-align: left;
        padding: 30px 0;
    }
    .container {
        background: #fff;
    }
}
.content {
    padding: 0 30px;
    .classify-label {
        font-size: 16px;
        font-weight: 600;
        border-bottom: 1px solid #dddfe3;
        padding-top: 30px;
        margin-bottom: 20px;
    }
}
.post-form {
    .form-col {
        padding: 0 10px;
    }
}
.header {
    position: relative;
    padding: 20px 30px;
    border-bottom: 1px solid #dddfe3;
    .title {
        font-size: 20px;
        line-height: 28px;
        color: #222831;
        margin-right: 120px;
        font-weight: 600;
        position: relative;
        .salary {
                position: absolute;
                color: #ff6b6b;
                font-size: 16px;
                line-height: 28px;
                right: -120px;
                top: 0;
            }
    }
    .status {
        margin-top: 15px;
        margin-right: 96px;
        color: #89909e;
        .item {
            padding: 0 10px;
            border-right: 1px solid #dddfe3;
        }
        .item:first-child {
            padding-left: 0;
        }
        .item:last-child {
            border-right: none;
        }
    }
}
.footer {
    padding: 10px 20% 30px 20%;
}
.urgent{
    display: inline-block;
    height: 20px;
    color: #fff;
    font-size: 12px;
    line-height: 20px;
    padding: 0 4px;
    margin-right: 4px;
    background: #ff6b6b;
}

</style>
<style scoped>
.post-form >>> .el-form-item__label {
    line-height: 20px;
    padding-bottom: 5px;
}
.input-with-select >>> .el-input-group__prepend{
    background-color: #fff;
}
.input-with-select >>> .el-select .el-input{
    width: 180px;
}
</style>
